import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "@/components/Reveal";

const REQUIREMENTS = [
  "Maggiore età (18 anni compiuti)",
  "Patente di guida B",
  "Auto propria per le consegne",
  "Smartphone con accessori per la ricarica",
  "Carta d'identità in corso di validità",
  "Permesso di soggiorno valido (per cittadini extra-UE)",
  "Buona conoscenza della lingua italiana",
];

export const RequirementsSection = () => (
  <section id="requisiti" data-testid="requirements-section" className="relative py-24 sm:py-32 px-5 sm:px-8">
    <div className="max-w-6xl mx-auto">
      <SectionHeading
        eyebrow="01 — Requisiti"
        title="Cosa devi avere per lavorare come Responsabile delle Consegne"
        sub="Pochi requisiti, tutti essenziali. Se li hai, sei già un passo avanti."
        testid="requirements-title"
      />

      <div className="border-t border-brand/15">
        {REQUIREMENTS.map((req, i) => (
          <motion.div
            key={req}
            data-testid={`requirement-item-${i + 1}`}
            initial={{ opacity: 0, x: -32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group flex items-center gap-5 sm:gap-8 py-5 sm:py-6 border-b border-brand/15 hover:bg-card2/50 hover:pl-3 sm:hover:pl-5 transition-all duration-300 cursor-default"
          >
            <span className="font-display font-black text-2xl sm:text-4xl text-brand/30 group-hover:text-brand transition-colors duration-300 w-12 sm:w-16 shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            <p className="flex-1 font-display font-bold text-base sm:text-xl text-white/85 group-hover:text-white transition-colors duration-300">
              {req}
            </p>
            <ArrowUpRight className="w-5 h-5 text-brand opacity-0 group-hover:opacity-100 transition-opacity duration-300 shrink-0" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
